import React from 'react';
// Rutas
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// Componente ScrollToTop
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
// Páginas
import Home from './pages/Home';
import About from './pages/DiplomadosDisponibles';
import Contact from './pages/Contact';
import DiplomadoBasico from './pages/DiplomadoBasico';
import DiplomadoAvanzado from './pages/DiplomadoAvanzado';
import Maestria from './pages/Maestria';
import NotasInformativas from './pages/NotasInformativas';
// Componentes
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Chatbot from './components/Chatbot/Chatbot'

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/diplomado-basico" element={<DiplomadoBasico />} />
                <Route path="/diplomado-avanzado" element={<DiplomadoAvanzado />} />
                <Route path="/maestria" element={<Maestria />} />
                <Route path="/notas-informativas" element={<NotasInformativas />} />
            </Routes>
            <Footer />
            <Chatbot />
        </BrowserRouter>
    );
}

export default App;
